import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setLicencaPaternidadeSaudeIndigenaEEscritoriosRegionais(params: Params): CustomFormQuestion[] {
  const { questions } = params

  return questions
}
